import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormDialog } from "ui/form-dialog";
import SelectedRemovableItems from "components/partials/selected-removable-items/selected-removable-items";
import CampaignFolderSelect from "components/partials/campaign-folder-select/campaign-folder-select";
import type { TouchpointAttributes } from "hooks/api/use-touchpoints";

interface SelectedTouchpointsFolderModalProps {
  title: string;
  description: string;
  submitButtonLabel: string;
  submittingLabel?: string;
  onCloseCallback: () => void;
  onConfirmCallback: () => void;
  selectedList: TouchpointAttributes[];
  folderId: string;
  setFolderId: (folderId: string) => void;
  isSubmitDisabled: boolean;
  isSubmitting: boolean;
  onRemoveSelectedItem: (itemId: string) => void;
  clientId: string;
  campaignId: string;
}

const SelectedTouchpointsFolderModal = ({
  title,
  description,
  submitButtonLabel,
  submittingLabel,
  onCloseCallback,
  onConfirmCallback,
  selectedList,
  folderId,
  setFolderId,
  isSubmitDisabled,
  isSubmitting,
  onRemoveSelectedItem,
  clientId,
  campaignId,
}: SelectedTouchpointsFolderModalProps) => {
  const hasItems = selectedList.length > 0;
  const form = useForm({ mode: "onChange", shouldUnregister: true });

  useEffect(() => {
    if (!hasItems) {
      onCloseCallback();
    }
  }, [hasItems, onCloseCallback]);

  const handleConfirm = () => {
    if (!hasItems) return;
    onConfirmCallback();
  };

  return (
    <FormDialog
      open
      onClose={onCloseCallback}
      headline={title}
      description={description}
      form={form}
      onSubmit={handleConfirm}
      submitDisabled={isSubmitDisabled}
      submitting={isSubmitting}
      submitButtonText={submitButtonLabel}
      submitLoadingMessage={submittingLabel}>
      <CampaignFolderSelect
        selectName="touchpoints-folder-select"
        label="Folder name"
        ariaLabel="Choose folder"
        value={folderId}
        onChange={setFolderId}
        clientId={clientId}
        campaignId={campaignId}
        isRequired
      />

      <SelectedRemovableItems
        selectedList={selectedList}
        onRemoveSelectedItem={onRemoveSelectedItem}
      />
    </FormDialog>
  );
};

export default SelectedTouchpointsFolderModal;
